// extracted by mini-css-extract-plugin
export var checkoutRateBadge = "_ui-0";
export var checkoutRateBadgeLink = "_ui-1";